<template>
  <div>
    <v-card>
      <v-card-title> Busqueda de huella </v-card-title>
      <v-card-text v-if="ip">
        <v-tabs v-model="tab">
          <v-tab>Buscar Huella</v-tab>
          <v-tab>Configuración</v-tab>
        </v-tabs>
        <v-tabs-items v-model="tab">
          <v-tab-item>
            <v-select
              v-if="false"
              v-model="fingerReaderDevice"
              :items="fingerReaderDevices"
              :item-text="'product_name'"
              :item-value="'lector_id'"
              @input="onSelectDevices"
              attach
              label="Dispositivo lector de huellas en uso"
            ></v-select>
            <div v-if="!devicedNotDetected">
              <v-btn
                v-if="!startProcess"
                color="primary"
                @click="startCapture()"
              >
                Buscar huella
              </v-btn>
              <h2 v-if="startProcess && !fingerFound & !fingerNotFound">
                {{ textProcess }}
              </h2>
              <h3 v-if="startProcess && !fingerFound & !fingerNotFound">
                Escaneando huella: {{ scannTimes }}
              </h3>
              <v-progress-linear
                v-if="scanning && !fingerFound & !fingerNotFound"
                indeterminate
                color="teal"
              ></v-progress-linear>
              <h1 v-if="fingerFound & !fingerNotFound">Huella encontrada</h1>
  
              <v-alert v-if="fingerNotFound" dense outlined type="error">
                Error buscando huella {{ errorText }}
                <div v-if="profile">En uso por:{{ profile.NCompleto }}</div>
                <v-row align="center" no-gutters>
                  <v-col md="6" class="shrink">
                    <v-btn
                      block
                      class="mx-2"
                      color="info"
                      @click="retryAddCapture()"
                      outlined
                    >
                      Reintentar
                    </v-btn>
                  </v-col>
                  
                </v-row>
              </v-alert>
              <v-alert v-if="fingerFound " dense outlined type="success">
                Huella encontrada
                <div v-if="profile">En uso por:{{ profile.NCompleto }}</div>
                <v-row align="center" no-gutters>
                  <v-col md="6" class="shrink">
                    <v-btn
                      block
                      class="mx-2"
                      color="info"
                      @click="retryAddCapture()"
                      outlined
                    >
                      Buscar de nuevo
                    </v-btn>
                  </v-col>

                </v-row>
              </v-alert>
            </div>
            <h1 v-if="devicedNotDetected">Ningun escaner conectado</h1>
          </v-tab-item>
          <v-tab-item>
            <h4>Configure la IP del servidor de huellas</h4>
            <v-text-field
              v-model="ipForSet"
              label="IP de servidor"
            ></v-text-field>
            <v-btn color="primary" @click="saveIp()">Guardar IP</v-btn>
          </v-tab-item>
        </v-tabs-items>
      </v-card-text>
      <v-card-text v-if="!ip">
        <h4>Configure la IP del servidor de huellas</h4>
        <v-text-field v-model="ipForSet" label="IP de servidor"></v-text-field>
        <v-btn color="primary" @click="saveIp()">Guardar IP</v-btn>
      </v-card-text>
    </v-card>
  </div>
</template>

<style scoped></style>

<script>
import ApiFingerReader from "../../../clases/PGSFingerReader/ApiFingerReader.js";
import { FingerReaderSignals } from "../../../clases/PGSFingerReader/pgs-finger-signals.js";
import Cliente from "../../../clases/Cliente.js";
import {
  PGSFMDClient,
  PGSEnrollmentClient,
  PGSServiceConnection,
} from "../../../clases/PGSFingerReader/pgs-biometric-client.js";

export default {
  name: "FingerClientSync",
  components: {},
  props: ["cliente"],
  data() {
    return {
      devicedNotDetected: true,
      tab: 0,
      ip: null,
      ipForSet: null,
      fingerReaderDevice: null,
      fingerReaderDevices: [],
      fingerFound: false,
      fingerNotFound:false,
      creator: {
        Id: "",
        Nombre: "",
        Tipo: "Cajero",
      },
      profile: null,
      sendingData: false,
      startProcess: false,
      scannFinish: false,
      fingerData: null,
      scannTimes: 1,
      scanning: false,
      errorScanning: false,
      errorText: "",
      dataFinger: null,
      dpDevice: null,
      frSignals: null,
      dpConnection: null,
      dpEnrollment: null,
      fmdClient: null,
    };
  },
  methods: {
    async getProfile(id) {
      
      /*try {
        const { status, data } = await this.$axios().get(`/employee/${id}`)
        if (status === 200) {
          this.profile = {}
        }
      } catch (e) {
        this.$snotify.warning(e, 'Error al consultar empleado con huella')
      }*/
      let cliente = this.$pgsHelper.getById(this.data_clientes, "Id", id);
      
      this.profile = cliente;
    },
    saveIp() {
      localStorage.setItem("fingerReaderServer", this.ipForSet);
      this.ip = this.ipForSet;
    },
    onSelectDevices() {
      this.dpConnection = new PGSServiceConnection();
      this.fmdClient = new PGSFMDClient(this.dpConnection);
      //this.dpEnrollment = new PGSEnrollmentClient(this.dpConnection);
    },
    async startCapture() {
      this.startProcess = true;
      //this.dpEnrollment.beginEnrollment();
      this.scanningProcess();
    },
    async retryAddCapture() {
      this.errorScanning = false;
      this.scannFinish = false;
      this.fingerNotFound = false;
      this.fingerFound = false;
      await this.forceEndCapture();
    },
    async forceEndCapture() {
      this.scannTimes = 1;
      this.errorScanning = false;
      /*if (this.dpEnrollment) {
        await this.dpEnrollment.cancelEnrollment();
      }*/

      this.scanning = false;
      this.startProcess = false;
    },
    async scanningProcess() {
      this.scanning = true;
      const { fp: fpRaw } = await this.frSignals.readFingerPrint();
      
      const fmdResponse = await this.fmdClient.fromRaw(
        fpRaw.Vendor,
        fpRaw.Quality,
        fpRaw.Data
      );
      await this.getData(fmdResponse.fmd);
      /*let res = await this.dpEnrollment.addToEnrollment(fmdResponse.fmd)
      
      if (res.status == 1) {
        this.scannTimes++
        await this.scanningProcess()
      } else if (res.status == 2) {
        let end = await this.dpEnrollment.endEnrollment()
        this.dataFinger = end.fmd
        
        this.scannFinish = true
        await this.saveData(this.dataFinger)
      } else {
        this.errorText = res.message
        this.errorScanning = true
      }*/
    },
    async getData(fingerData, force = null) {
      this.errorScanning = false;
      this.sendingData = true;
      let api = await ApiFingerReader.getInstance();

      let baseURL = "http://" + this.ip + "";
      let ipProxy = "http://127.0.0.1:4581"; //'http://10.147.18.67:7000' //http://127.0.0.1:7000
      let body = JSON.stringify({
        url: baseURL + "/fingerprint/find-by-fmd",
        method: "POST",
        body: {
          fmd: fingerData,
        },
        headers: { "Content-Type": "application/json" },
      });

      let devices = await api.post(ipProxy + "/proxy", body, {
        headers: {
          "Content-Type": "text/plain",
        },
      }).catch((error) => {
        this.errorText = "huella no encontrada"
        this.profile= null
        this.fingerNotFound = true;
      });
      
      if (devices?.status == 200) {
        this.fingerFound = true;
        this.getProfile(devices.data.data.pgrb_ssid)
      } else {
        this.profile= null
        this.errorText = devices.data.data.message
        this.fingerNotFound = true;
      }
    },
    onNoDevices() {
      this.devicedNotDetected = true;
    },
    onDevices() {
      this.devicedNotDetected = false;
    },
    onFingerPrint() {
      
    },
  },
  computed: {
    data_clientes() {
      let clientes = [];
      let rowclientes = Cliente.getClientsList();
      rowclientes.forEach((element) => {
        if (element.Id != "PUBLICOGENERAL") {
          element.NombreAlias =
            element.Nombres + (element.Apodo ? " (" + element.Apodo + ")" : "");
          element.NCompleto =
            element.Nombres +
            " " +
            element.Apellidos +
            (element.Apodo ? " (" + element.Apodo + ")" : "");
          clientes.push(element);
        }
      });
      return clientes;
    },
    user() {
      //const sessionCookie = this.$cookies.get('RhSession')
      //return sessionCookie ? sessionCookie.name : ''
      let claims = this.$route.params.user.tokenResult.claims;
      return claims.name;
    },
    claims() {
      //const sessionCookie = this.$cookies.get('RhSession')
      //return sessionCookie ? sessionCookie.name : ''
      let claims = this.$route.params.user.tokenResult.claims;
      return claims;
    },
    textProcess() {
      let text = "Coloque su dedo sobre el sensor para la primera captura";
      if (this.scannTimes == 2) {
        text = "Vuelva a poner el dedo en el sensor";
      }
      if (this.scannTimes == 3) {
        text = "Una vez mas";
      }
      if (this.scannTimes >= 4) {
        text = "Ya casi, una vez mas";
      }
      return text;
    },
  },
  async beforeDestroy() {
    
    //await this.forceEndCapture();
    await this.frSignals.destroy();
    this.frSignals.removeEventListener("onNoDevices", () => {
      
     
    });
    this.frSignals.removeEventListener("onDevices", () => {
      
      
    });
    this.frSignals.removeEventListener("onFingerPrint", () => {
     
    });
  },
  destroyed: function() {},
  watch: {},
  beforeMount: function() {},
  async mounted() {
    if (localStorage.getItem("fingerReaderServer")) {
      this.ip = localStorage.getItem("fingerReaderServer");
      this.ipForSet = localStorage.getItem("fingerReaderServer");
    }
    this.creator.Id = this.claims.user_id || "admin";
    this.creator.Nombre = this.user;

    this.frSignals = new FingerReaderSignals(
      FingerReaderSignals.SampleFormats.Raw
    );
    this.dpConnection = new PGSServiceConnection("http://127.0.0.1:4582"); // entollment ip
    this.fmdClient = new PGSFMDClient(this.dpConnection);
    //this.dpEnrollment = new PGSEnrollmentClient(this.dpConnection);
    //
    this.frSignals.addEventListener("onNoDevices", () => {
      
      this.onNoDevices();
    });
    this.frSignals.addEventListener("onDevices", () => {
      
      this.onDevices();
    });
    this.frSignals.addEventListener("onFingerPrint", () => {
      this.onFingerPrint();
    });
    try {
      await this.frSignals.init();
    } catch (err) {
      console.error(err);
    }
  },
};
</script>
